<template>
  <div v-if="stockcarId" class="tooltip">
    <strong>{{ i18n.t('/StockDashboard/ReservationStatus/Title') }}</strong>
    <app-tooltip
      :title="i18n.t('/StockDashboard/ReservationStatus/Title')"
      class="stock-status-tooltip"
    >
      <stock-reservation-status :stock-car-id="stockcarId" />
    </app-tooltip>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import StockReservationStatus from '@/components/generic/presentational/molecules/stockReservationStatus/StockReservationStatus.vue'
import AppTooltip from '@/components/generic/presentational/molecules/appTooltip/AppTooltip.vue'

export default {
  components: {
    StockReservationStatus,
    AppTooltip,
  },
  data() {
    return {
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
      showStockOrderModal: false,
    }
  },
  computed: {
    ...mapState('quote', ['car']),
    stockcarId() {
      return this.car?.StockCarId
    },
  },
}
</script>

<style lang="scss" scoped>
.stock-status-tooltip {
  display: inline;
}
</style>
